let blinkTimer: number | null = null;
let stopTimer: number | null = null;
let cleanupListeners: Array<() => void> = [];

function clearTitleAlert(finalTitle = '每日启动器'): void {
  if (blinkTimer !== null) {
    window.clearInterval(blinkTimer);
    blinkTimer = null;
  }
  if (stopTimer !== null) {
    window.clearTimeout(stopTimer);
    stopTimer = null;
  }
  cleanupListeners.forEach((cleanup) => cleanup());
  cleanupListeners = [];
  document.title = finalTitle;
}

export function startTimerDoneTitleAlert(cardTitle: string): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  clearTitleAlert();

  const baseTitle = '每日启动器';
  const alertTitle = `时间到 · ${cardTitle}`;
  let showingAlert = false;

  const tick = () => {
    showingAlert = !showingAlert;
    document.title = showingAlert ? alertTitle : baseTitle;
  };
  const stop = () => clearTitleAlert(baseTitle);
  const stopWhenVisible = () => {
    if (!document.hidden) stop();
  };

  window.addEventListener('focus', stop);
  document.addEventListener('visibilitychange', stopWhenVisible);
  document.addEventListener('pointerdown', stop);
  document.addEventListener('keydown', stop);
  cleanupListeners = [
    () => window.removeEventListener('focus', stop),
    () => document.removeEventListener('visibilitychange', stopWhenVisible),
    () => document.removeEventListener('pointerdown', stop),
    () => document.removeEventListener('keydown', stop),
  ];

  tick();
  blinkTimer = window.setInterval(tick, 650);
  stopTimer = window.setTimeout(stop, 30000);
}
